$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  $('.submenu-li').parent('ul').addClass('sub-menu');
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.bannermenu-li').parent('ul').addClass('banner-menu');

  $('.slow-window').fadeOut('slow');

  var popup = localStorage.getItem('popup_value'); 
  if(popup != 1){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });
  $("button.navbar-toggle").on('click', function() {
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });

  $(".close-box").on('click', function() {
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });

  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $(".shopping-cart-close i").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
     $("body").removeClass("hidden");
  });

  $(".ajax-spin-cart").on("click", function () {
    if (this.dataset.skipCartDrawer === 'true') return;

    const form = this.closest("form");

    if (form) {
      const missingRequiredOption = [...form.querySelectorAll(".gpo-element")]
        .filter(group => group.querySelector(".gpo-label.required"))
        .some(group => {
          const checked = group.querySelector(
            'input[type="radio"]:checked, input[type="checkbox"]:checked'
          );

          const filled = [...group.querySelectorAll(
            'select, textarea, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])'
          )].some(field => String(field.value || "").trim() !== "");

          return !checked && !filled;
        });

      if (missingRequiredOption) return;
    }

    window.setTimeout(function () {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    }, 1000);
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  $(".mm-fullscreen-bg").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $(".filter-sidebar").removeClass("active");
    $("body").removeClass("hidden");
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

      
  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    return false;
    });
  });

$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }

  var sticky = $('.header-area'),
  scroll = $(window).scrollTop();
  if (scroll >= 150) {
    sticky.addClass('is-sticky');
  }
  else {
    sticky.removeClass('is-sticky');
  }
  
});


// =============================================
// Globo Color Image → Cart Fix
// =============================================
document.addEventListener('DOMContentLoaded', function() {

  function captureGloboColorImage() {
    // Globo ke swatch items pe click listener
    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('.gpop-up-swatch-item, .gpo-swatch-item, [class*="gpo"][class*="swatch"], [class*="gpop"][class*="item"]');
      if (!swatch) return;

      // Us swatch ki image dhundho
      var swatchImg = swatch.querySelector('img');
      var imageUrl = null;

      if (swatchImg) {
        imageUrl = swatchImg.src;
      } else if (swatch.style.backgroundImage) {
        imageUrl = swatch.style.backgroundImage.replace(/url\(["']?/, '').replace(/["']?\)/, '');
      }

      if (!imageUrl) return;

      // Form mein _image hidden input set karo ya create karo
      var form = swatch.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var hiddenInput = form.querySelector('input[name="properties[_image]"]');
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[_image]';
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = imageUrl;
    });
  }

  captureGloboColorImage();

  // Cart drawer mein image update karo
  function updateCartImages() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cart.items.forEach(function(item) {
          var imageUrl = null;

          // _image property check karo
          if (item.properties && item.properties['_image']) {
            imageUrl = item.properties['_image'];
          }

          if (!imageUrl) return;

          // Mini cart mein image update karo
          var cartImgs = document.querySelectorAll('.cart-item img.img-fluid, .item-img img.img-fluid');
          cartImgs.forEach(function(img) {
            var li = img.closest('li.cart-item, li.grid-wrapper');
            if (li) {
              var titleEl = li.querySelector('a[title], .item-title a');
              if (titleEl && titleEl.textContent.trim().includes(item.product_title.substring(0, 15))) {
                img.src = imageUrl;
              }
            }
          });
        });
      });
  }

  // Cart update hone par images refresh karo
  var observer = new MutationObserver(function() {
    updateCartImages();
  });

  var cartContainer = document.querySelector('.cart-item-loop, .cart-item-wrap');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  // Ajax cart callback ke baad bhi run karo
  $(document.body).on('afterCartLoad.ajaxCart', function() {
    setTimeout(updateCartImages, 500);
  });
});
